__turbopack_context__.v({
  "registration": "Registration-module__27jA8W__registration",
  "registrationText": "Registration-module__27jA8W__registrationText",
});
